//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    totalCount: {
      type: Number,
      default: 0
    },
    filterCatalogs: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      notAsk: false,
      currentLimit: 0
    }
  },
  watch: {
    totalCount: function (c) {
      this.currentLimit = c
    }
  },
  methods: {
    onLimit: function () {
      this.$emit('set-no-ask', this.notAsk)
      this.$emit('get-limit-catalogs-search', this.filterCatalogs, this.currentLimit)
    },
    onFull: function () {
      this.$emit('set-no-ask', this.notAsk)
      this.$emit('get-limit-catalogs-search', this.filterCatalogs, this.totalCount + 5000)
    },
    onHide: function () {
      if (this.$refs.refBtnPopupClose !== undefined && this.$refs.refBtnPopupClose.$el !== undefined) {
        this.$refs.refBtnPopupClose.$el.click()
      }
    }
  }
}
